import * as React from 'react';

export const VIEW_MODES = {
  LIST: 'list',
  FORM: 'form',
  FILE_MANAGER: 'fileManager',
  SEND_FILE: 'sendFile',
};

export const useViewNavigation = () => {
  const [viewMode, setViewMode] = React.useState(VIEW_MODES.LIST);
  const [formState, setFormState] = React.useState({
    isUpdate: false,
    produto: null,
    title: '',
  });
  const [fileManagerState, setFileManagerState] = React.useState({
    codigoProduto: '',
    subtitle: '',
  });

  const navigateToList = React.useCallback(() => {
    setViewMode(VIEW_MODES.LIST);
  }, []);

  const navigateToNewProduct = React.useCallback(() => {
    setViewMode(VIEW_MODES.FORM);
    setFormState({
      isUpdate: false,
      produto: null,
      title: 'Novo produto',
    });
  }, []);

  const navigateToEditProduct = React.useCallback((produto) => {
    setViewMode(VIEW_MODES.FORM);
    setFormState({
      isUpdate: true,
      produto,
      title: 'Editar produto',
    });
  }, []);

  const navigateToFileManager = React.useCallback((produto) => {
    setViewMode(VIEW_MODES.FILE_MANAGER);
    setFileManagerState({
      codigoProduto: produto.idPortfolio,
      subtitle: `${produto.idPortfolio} - ${produto.nome}`,
    });
  }, []);

  const navigateToSendFile = React.useCallback(() => {
    setViewMode(VIEW_MODES.SEND_FILE);
  }, []);

  // Volta do envio para a gestão de arquivos mantendo o produto já selecionado
  const navigateBackToFileManager = React.useCallback(() => {
    setViewMode(VIEW_MODES.FILE_MANAGER);
  }, []);

  const handleBackNavigation = React.useCallback(() => {
    if (viewMode === VIEW_MODES.SEND_FILE) {
      setViewMode(VIEW_MODES.FILE_MANAGER);
    } else {
      setViewMode(VIEW_MODES.LIST);
    }
  }, [viewMode]);

  const updateFormTitle = React.useCallback((title) => {
    setFormState((prev) => ({ ...prev, title }));
  }, []);

  const updateFormIsUpdate = React.useCallback((isUpdate) => {
    setFormState((prev) => ({ ...prev, isUpdate }));
  }, []);

  return {
    viewMode,
    formState,
    fileManagerState,
    navigateToList,
    navigateToNewProduct,
    navigateToEditProduct,
    navigateToFileManager,
    navigateToSendFile,
    navigateBackToFileManager,
    handleBackNavigation,
    updateFormTitle,
    updateFormIsUpdate,
  };
};
